import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';
import { subcategories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
            影视分类
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const subCats = subcategories[cat.slug] || [];
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-100 rounded-xl p-5 cursor-pointer hover:bg-background-200 transition-colors"
              >
                <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center mb-3 group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${cat.icon} text-lg text-primary-400`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2">
                  {cat.name}
                </h3>
                <div className="flex flex-wrap gap-1">
                  {subCats.slice(0, 4).map((sub) => (
                    <span
                      key={sub.slug}
                      className="text-[11px] text-foreground-500 bg-background-200 px-2 py-0.5 rounded"
                    >
                      {sub.name}
                    </span>
                  ))}
                  {subCats.length > 4 && (
                    <span className="text-[11px] text-foreground-600">
                      +{subCats.length - 4}
                    </span>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}